import { toast } from 'react-toastify'

import { formattedMessage } from '../../CurrentLocale'

const handleSuccess = () => toast.success(formattedMessage({ id: 'updated' }))

export default handleSuccess
